(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lmx-restoration-carousel"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.lmx-restoration-carousel').forEach(function(section) {
    var track   = section.querySelector('.lmx-rc-track');
    var cards   = Array.from(section.querySelectorAll('.lmx-rc-card'));
    var prevBtn = section.querySelector('.lmx-rc-prev');
    var nextBtn = section.querySelector('.lmx-rc-next');
    var dotsWrap = section.querySelector('.lmx-rc-dots');
    var current = 0;

    // Build dots
    if (dotsWrap && cards.length > 0) {
      cards.forEach(function(_, i) {
        var dot = document.createElement('button');
        dot.className = 'lmx-rc-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to restoration ' + (i + 1));
        dot.addEventListener('click', function() { goTo(i); });
        dotsWrap.appendChild(dot);
      });
    }

    function getDots() { return dotsWrap ? Array.from(dotsWrap.querySelectorAll('.lmx-rc-dot')) : []; }

    function goTo(index) {
      if (!cards.length) return;
      current = Math.max(0, Math.min(index, cards.length - 1));
      cards[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      getDots().forEach(function(d, i) { d.classList.toggle('active', i === current); });
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === cards.length - 1;
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    // Sync dots on manual scroll
    if (track) {
      track.addEventListener('scroll', function() {
        var center = track.scrollLeft + track.offsetWidth / 2;
        var closest = 0, closestDist = Infinity;
        cards.forEach(function(card, i) {
          var dist = Math.abs((card.offsetLeft + card.offsetWidth / 2) - center);
          if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        if (closest !== current) {
          current = closest;
          getDots().forEach(function(d, i) { d.classList.toggle('active', i === current); });
          if (prevBtn) prevBtn.disabled = current === 0;
          if (nextBtn) nextBtn.disabled = current === cards.length - 1;
        }
      });
    }

    goTo(0);

    // Before/After slider logic
    section.querySelectorAll('.lmx-ba-wrap').forEach(function(wrap) {
      var slider  = wrap.querySelector('.lmx-ba-slider');
      var after   = wrap.querySelector('.lmx-ba-after');
      var divider = wrap.querySelector('.lmx-ba-divider');

      function update(val) {
        var pct = val + '%';
        if (after)   after.style.clipPath   = 'inset(0 ' + (100 - val) + '% 0 0)';
        if (divider) divider.style.left     = pct;
      }

      if (slider) {
        slider.addEventListener('input', function() { update(this.value); });
        update(50);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
